import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ZONING_OPTIONS } from '../config/ci-options.config';
import { LandValueForm, PropertyCategory } from '../models/ci-form.model';
import { UiCalculatedBoxComponent } from '../ui/ui-calculated-box.component';
import { UiInputComponent } from '../ui/ui-input.component';
import { UiNoteBarComponent } from '../ui/ui-note-bar.component';
import { UiSelectComponent } from '../ui/ui-select.component';
import { formatCompactCurrency, formatPsf } from '../../../core/utils/format.util';

@Component({
  selector: 'ci-step-land-value',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ReactiveFormsModule,
    UiInputComponent,
    UiSelectComponent,
    UiCalculatedBoxComponent,
    UiNoteBarComponent,
  ],
  templateUrl: './step-land-value.component.html',
})
export class StepLandValueComponent {
  readonly form = input.required<LandValueForm>();
  readonly category = input.required<PropertyCategory>();
  /** Plot area from step 1 — land value is rate × area. */
  readonly plotArea = input<number | null>(null);
  readonly askingPrice = input<number | null>(null);

  readonly zoningOptions = ZONING_OPTIONS;

  landValue(): string {
    const rate = this.form().getRawValue().landRatePsf;
    const area = this.plotArea();
    if (!rate || !area) return '—';
    return formatCompactCurrency(rate * area);
  }

  askingPsf(): string {
    const price = this.askingPrice();
    const area = this.plotArea();
    if (!price || !area) return '—';
    return formatPsf(price / area);
  }

  isHouse(): boolean {
    return this.category() === 'independent-house';
  }
}
